// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-8Q3","type":"styles_type__3GeCU","choices":"styles_choices__pvUN8"};